import React from "react";

export type FieldStatus = "onFile" | "missing";

interface IFieldStatusBadgeProps {
  status: FieldStatus;
}

const BADGE_STYLES: Record<FieldStatus, { className: string; label: string }> = {
  onFile: {
    className: "border-[#459796] bg-[#DBE7E7] text-[#459796]",
    label: "On file",
  },
  missing: {
    className: "border-[#ED7857] bg-[#F7E3DC] text-[#ED7857]",
    label: "Missing",
  },
};

export const FieldStatusBadge = ({ status }: IFieldStatusBadgeProps) => {
  const { className, label } = BADGE_STYLES[status];
  const baseClassName =
    "geograph-medium ml-auto inline-flex h-5 items-center rounded border px-1 text-[10px] leading-none normal-case";

  return (
    <span className={`${baseClassName} ${className}`}>
      {label}
    </span>
  );
};

export default FieldStatusBadge;
